import Dashboard from '../../../layouts/SeekerShell.vue';
import Tiles from '../views/DashboardTiles.vue';
import Status from '../views/Statusboard.vue';
import JobSeekerInfo from '../views/JobSeekerInfoDialog.vue';
import DeclineJobMatchDialog from '../views/DeclineJobMatchDialog.vue';
import AcceptJobMatchDialog from '../views/AcceptJobMatchDialog.vue';
import VacantRoleMatches from '../components/VacantRoleMatches.vue';
import JobSeekerApplications from '../views/JobSeekerApplications.vue';
import AcceptOfferDialog from '../views/AcceptOfferDialog.vue';
import ConfirmApplyForRoleDialog from '../views/ConfirmApplyForRoleDialog.vue';
import JobSeekerDashboard from '../views/JobSeekerDashboard.vue';
import JobSeekerApplicationsDashboard from '../views/JobSeekerApplicationsDashboard.vue';
import VacantRoleInfo from '../components/VacantRoleInfo.vue';
// COVID-19
import Covid19Dashboard from '../views/covid19/dashboard-covid.vue';

// Job Matches Archive
import JobMatchesArchive from '../views/JobMatchesArchive.vue';

// New Role matches page
import RoleMatchingPage from '../views/vacant-role-matching.vue';
import RolePostingPage from '../views/vacant-role-posting.vue';

//Search Job
import SearchJobsPage from '../views/SearchJobs.vue';

import MyReferrals from '../views/my-referrals.vue';

import JobSeekerProfilePageSetting from '../views/profilepage/JobSeekerProfilePageSetting.vue';

export default [{
    path: '/',
    name: 'dashboardModule',
    component: Dashboard,
    children: [{
        path: '/jobseeker-dashboard/',
        name: 'jobseeker-dashboard',
        component: Tiles,
        title: 'Tiles',
        meta: {
          requiredRole: 'JobSeeker',
        },
      },
      {
        path: '/jobseeker-initiated-dashboard/jobseeker-statusboard/:activeTab',
        name: 'jobseeker-statusboard',
        component: Status,
        title: 'Status'
      },
      {
        path: '/jobseekerinfo-dialog/:data',
        name: 'JobSeekerInfoDialog',
        component: JobSeekerInfo,
        title: 'JobSeeker Info',
      },
      {
        path: '/jobseekerdecline-dialog/:data',
        name: 'DeclineJobMatchDialog',
        component: DeclineJobMatchDialog,
        title: 'Decline Dialog',
      },
      {
        path: '/jobseekeraccept-dialog/:data',
        name: 'AcceptJobMatchDialog',
        component: AcceptJobMatchDialog,
        title: 'Accept Dialog',
      },
      {
        path: '/jobseeker-dashboard/vacant-role-matches',
        name: 'VacantRoleMatches',
        component: VacantRoleMatches,
        title: 'Accept Dialog',
      },
      {
        path: '/jobseeker-applications-dashboard/jobseeker-initiated-applications/',
        name: 'JobSeekerApplications',
        component: JobSeekerApplications,
        title: 'Job Seeker-Initiated Applications'
      },
      {
        path: '/jobseekeracceptoffer-dialog/:data',
        name: 'AcceptOfferDialog',
        component: AcceptOfferDialog,
        title: 'Accept Offer Dialog',
      },
      {
        path: '/apply-for-role-dialog',
        name: 'ConfirmApplyForRoleDialog',
        component: ConfirmApplyForRoleDialog,
        title: 'Confirm Apply for Role',
      },
      {
        path: '/jobseeker-initiated-dashboard/',
        name: 'JobSeekerDashboard',
        component: JobSeekerDashboard,
        title: 'Company-initiated applications dashboard'
      },
      {
        path: '/jobseeker-applications-dashboard/',
        name: 'JobSeekerApplicationsDashboard',
        component: JobSeekerApplicationsDashboard,
        title: 'Job Seeker-initiated applications dashboard'
      },      
      {
        path: '/covid19/landing-dashboard',
        name: 'Covid19Dashboard',
        component: Covid19Dashboard,
        title: 'COVID-19 Dashboard',
      },
      {
        path: '/job-matches-archive',
        name: 'JobMatchesArchive',
        component: JobMatchesArchive,
        title: 'Job Matches Archive',
      },
      // new role-matching page
      {
        path: 'role-matching',
        name: 'role-matching',
        component: RoleMatchingPage,
        title: 'Role Matching',
      },
      {
        path: '/role-matching/vacant-role-info/',
        name: 'VacantRoleInfo',
        component: VacantRoleInfo,
        title: 'View Role Info'
      },
      // new vacant-role page
      {
        path: 'role-posting/:vacantid/:matchdetail',
        name: 'role-posting',
        component: RolePostingPage,
        title: 'Role Posting',
      },
      {
        path: '/my-referrals',
        name: 'MyReferrals',
        component: MyReferrals,
        title: 'My Referrals'
      },
      {
        path: '/profile/jobseeker-page-setting',
        name: 'JobSeekerProfilePageSetting',
        component: JobSeekerProfilePageSetting,
        title: 'Profile Page Settings',
        meta: {
          requiredRole: process.env.VUE_APP_ROLE_JOB_SEEKER
        }
      },
      // new search job page
      {
        path: 'search-jobs',
        name: 'search-jobs',
        component: SearchJobsPage,
        title: 'Search Jobs',
        meta: {
          requiredRole: process.env.VUE_APP_ROLE_JOB_SEEKER
        }
      },
    ]
  }];